/* eslint-disable @typescript-eslint/naming-convention */
export const variantStatus = {
  DaysToReturn: "(in {{count}} day).",
  DaysToReturn_plural: "(in {{count}} days).",
  DiscontinuedVariant:
    "This product is discontinued. Choose a different size or browse similar products.",
  NEW_BackorderedWithNoReturnDate:
    "Backordered means that it may take us a little longer to ship this item to you. If 21 consecutive days pass after you checkout, we’ll cancel the order and refund the amount to the card you paid with. We’ll keep you updated by email.",
  BackorderedWithReturnDate: "Size backordered until approx.",
  OLD_BackorderedWithNoReturnDate: "This product is backordered.",
  OutOfStockAvailabilityTag: "Out of stock",
  OutOfStockWithReturnDate: "Out of stock until approx.",
  OutOfStockWithNoReturnDate:
    "This product is out of stock. Choose a different size or browse similar products.",
} as const;
